<div *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div *ngIf="card && card.isExtensionPending" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="100">
    <mat-card class="content-card">
      <mat-card-content>
        <div style="background-color: #2dc5e3; padding: 5px; margin-top: 5px; border-radius: 3px;">
          An extension of this card is pending, waiting for activation...
        </div>


      </mat-card-content>
    </mat-card>
  </div>
</div>

<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="40">
    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>

          <h5 class="h-condensed">Card<span *ngIf="card"> {{ card.token }}</span><span *ngIf="card?.primaryCardId"> ⛓</span> </h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <img *ngIf="imageUrl" class="logo-large" [src]="imageUrl" height="50" style="margin-left: 15px;" />

        <div *ngIf="card && card.primaryCardId" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
          <div fxFlex="100">
            <div style="background-color: #e0da67; padding: 5px; margin-left: 10px; margin-right: 10px; margin-top: 5px; border-radius: 3px;">
              This card is a secondary card of {{ card.primaryToken }}.
            </div>

          </div>
        </div>


        <div *ngIf="card">
          <div class="list-item" fxLayout="row" *ngFor="let field of fields1">
            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>

          <div class="list-item" fxLayout="row" *ngFor="let field of fields2">
            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>
        </div>




        <br />

        <div *ngIf="card">
          <div class="list-item" fxLayout="row" *ngFor="let field of fieldsOrder">
            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>
        </div>

        <br />

      </mat-card-content>

      <mat-card-actions align="end">
        <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>
      </mat-card-actions>
    </mat-card>

    <app-object-comments-view [caption]="'Comments for ' + card?.token" [target]="commentsCardTarget" [objectId]="cardId" [comments]="cardComments"></app-object-comments-view>
    <app-event-log-view [logs]="logs" *ngIf="showLogs()"></app-event-log-view>

  </div>



  <div fxFlex="60">

    <mat-card class="content-card" *ngIf="card && card.product.productKey == 'king'">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Card Upgrades</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="card && card.product.productKey == 'king'">


          <div>
            <button [class.spinner]="_isUpgradingCard" [disabled]="_isUpgradingCard" mat-raised-button color="blue" (click)="upgradeKingToKingPlus()">💎 Upgrade king to king+</button>
          </div>

            <div style="margin-top: 10px;">Upgrade cost: {{ kingPlusUpgradeCost | number: '1.2-2' }}</div>
            <div>Card balance: <ng-container *ngIf="cardBalanceLastKnown">{{ cardBalanceLastKnown.avlBal | number: '1.2-2' }} *</ng-container></div>
            <div style="margin-left: 3px; font-size: .8em;">* taken from cache - might be inaccurate</div>


        </ng-container>


      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>


    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Change Product</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="card">
          <div  style="margin-left: 15px;">
            <mat-form-field>
              <mat-select placeholder="Change product" [(ngModel)]="newProductId">
                <mat-option *ngFor="let product of products" [value]="product.id">
                  {{ product.internalName }}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <button style="margin-left: 5px; " [class.spinner]="_isChangingProduct" [disabled]="!card || _isChangingProduct || products.length == 0 || (newProductId == card.productId)" mat-raised-button color="blue" (click)="changeCardProduct()">Change product</button>
          </div>
        </ng-container>



      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>

    <mat-card class="content-card" *ngIf="card && card.secondaryCards && card.secondaryCards.length > 0">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Secondary Cards</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

          <div *ngFor="let secondary of card.secondaryCards" style="border: 1px dashed lightskyblue; border-radius: 5px; margin-bottom: 5px; margin-left: 5px;">
            <div class="list-item" fxLayout="row" *ngFor="let field of fieldsSecondaries">
              <app-content-row [field]="field" [entity]="secondary"></app-content-row>
            </div>
          </div>

      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Link card</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="card">
          <div  style="margin-left: 15px;">
            <div>Select a new primary card for this card.</div>
            <br />
            <div *ngIf="!card.primaryCardId" style="background-color: yellow; padding: 5px 10px; margin-top: 3px; border-radius: 5px;">
              <div>Once a card is a secondary card, it can <b>never</b> be made a primary card again. It can then only be linked to another primary card.</div>
              <div style="margin-top: 5px; margin-bottom: 5px;"><b>Use this function very carefully.</b></div>
            </div>
            <div *ngIf="!!card.primaryCardId" style="background-color: lightskyblue; padding: 3px; margin-top: 3px;">
              <div>⛓ This card is a secondary card currently linked to {{ card.primaryToken }}</div>
            </div>

            <div *ngIf="isLoadingOtherCards">
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>

            <div>
            <mat-form-field>
              <mat-select [disabled]="isLoading || isLoadingOtherCards || (otherCards.length == 0)" placeholder="Select new primary card" [(ngModel)]="newPrimaryCardId">
                <mat-option *ngFor="let c of otherCards" [value]="c.id" [disabled]="c.id == this.card.primaryCardId">
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.AllGood">🟢</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.ReferToCardIssuer">🟡</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardNotYetActivated">🟡</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.CaptureCard">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.DoNotHonour">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.InvalidCard">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.LostCard">🟡</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.StolenCard">🟠</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.ClosedAccount">⚫️</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.ExpiredCard">⚪️</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.TransactionNotPermittedToCardholder">🟡</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.SuspectedFraud">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.RestrictedCard">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.SecurityViolation">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardholderToContactIssuer">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardDestroyed">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.RefundGivenToCustomer">🔴</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardVoided">⚫️</span>

                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.ShortTermBlock">🟡</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.ShortTermFullBlock">🟡</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.LongTermBlock">🟠</span>
                  <span *ngIf="c.gpsCardStatus == gpsCardStatus.LongTermFullBlock">🟠</span>

                  {{ c.token }} - {{c.productName}}
                </mat-option>
              </mat-select>
            </mat-form-field>


            <button style="margin-left: 5px; " [class.spinner]="_isLinkingCard" [disabled]="!newPrimaryCardId || !card || _isLinkingCard || otherCards.length == 0" mat-raised-button color="blue" (click)="linkCard()">Link card</button>

            </div>


            <div style="background-color: lightgray; padding: 5px 10px; margin-top: 3px; border-radius: 5px;" *ngIf="!isLoading && !isLoadingOtherCards && (otherCards.length == 0)">
              This customer does not have any other cards that this card could be linked to.
            </div>


          </div>
        </ng-container>



      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>


    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Balance Transfer</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="card">
          <div style="margin-left: 15px;">

            <div>Transfer this card's balance to another of the customer's cards.</div>

            <div>

              <mat-form-field>
                <mat-select placeholder="Select destination card" [(ngModel)]="balanceTransferDestinationCardId">
                  <mat-option *ngFor="let c of otherCards" [value]="c.id">
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.AllGood">🟢</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.ReferToCardIssuer">🟡</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardNotYetActivated">🟡</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.CaptureCard">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.DoNotHonour">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.InvalidCard">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.LostCard">🟡</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.StolenCard">🟠</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.ClosedAccount">⚫️</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.ExpiredCard">⚪️</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.TransactionNotPermittedToCardholder">🟡</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.SuspectedFraud">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.RestrictedCard">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.SecurityViolation">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardholderToContactIssuer">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardDestroyed">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.RefundGivenToCustomer">🔴</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.CardVoided">⚫️</span>

                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.ShortTermBlock">🟡</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.ShortTermFullBlock">🟡</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.LongTermBlock">🟠</span>
                    <span *ngIf="c.gpsCardStatus == gpsCardStatus.LongTermFullBlock">🟠</span>

                    {{ c.token }} - {{c.productName}} <span *ngIf="c.id == this.card.primaryCardId">(primary)</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>


              <button style="margin-left: 5px; " [class.spinner]="_isBalanceTransferring" [disabled]="!balanceTransferDestinationCardId || !card || _isBalanceTransferring || otherCards.length == 0" mat-raised-button color="blue" (click)="balanceTransfer()">Transfer balance</button>

            </div>

            <div style="background-color: lightgray; padding: 5px 10px; margin-top: 3px; border-radius: 5px;" *ngIf="!isLoading && !isLoadingOtherCards && (otherCards.length == 0)">
              This customer does not have any other cards that a balance could be transferred to.
            </div>


          </div>
        </ng-container>



      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Card Operations</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ng-container *ngIf="card">

          <div style="margin-left: 15px;">
          <h5>Status</h5>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="33" class="secondary">Current Card Status (Portal / APP)</label>
            <label fxFlex="33" style="text-align: right">
              <div>
                {{ currentGpsStatusCached }}:&nbsp;
                <span>{{ gpsCardStatusHelper.getIcon(currentGpsStatusCached) }} {{ gpsCardStatusHelper.getText(currentGpsStatusCached) }}</span>

              </div>

            </label>

            <label fxFlex="33" style="text-align: right">

            </label>
          </div>

          <div class="list-item" fxLayout="row">
            <label fxFlex="33" class="secondary">Current Card Status (GPS)</label>
            <label fxFlex="33" style="text-align: right">
              <div>
                <ng-container *ngIf="!currentGpsStatus; else hasStatus">
                  <i>please query if necessary</i>
                </ng-container>
                <ng-template #hasStatus>
                  {{ currentGpsStatus }}:&nbsp;
                  <span *ngIf="currentGpsStatus == gpsCardStatus.AllGood">🟢 All Good</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ReferToCardIssuer">🟡 Refer to card issuer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardNotYetActivated">🟡 Card not yet activated</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CaptureCard">🔴 Capture card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.DoNotHonour">🔴 Do not honour</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.InvalidCard">🔴 Invalid card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LostCard">🟡 Lost card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.StolenCard">🟠 Stolen card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ClosedAccount">⚫️ Closed Account</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ExpiredCard">⚪️ Expired card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.TransactionNotPermittedToCardholder">🟡 Transaction not permitted to cardholder</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.SuspectedFraud">🔴 Suspected fraud</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.RestrictedCard">🔴 Restricted card</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.SecurityViolation">🔴 Security violation</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardholderToContactIssuer">🔴 Cardholder to contact issuer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.AllowableNumberOfPinTriesExceeded">Allowable number of PIN tries exceeded</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardDestroyed">🔴 Card destroyed</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.RefundGivenToCustomer">🔴 Refund given to customer</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.CardVoided">⚫️ Card voided</span>

                  <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermBlock">🟡 Short Term Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.ShortTermFullBlock">🟡 Short Term Full Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermBlock">🟠 Long Term Block</span>
                  <span *ngIf="currentGpsStatus == gpsCardStatus.LongTermFullBlock">🟠 Long Term Full Block</span>
                </ng-template>
              </div>

            </label>

            <label fxFlex="33" style="text-align: right">
              <div *ngIf="!currentUserIsPartner()">
                <button [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus" mat-stroked-button color="primary" (click)="queryCardStatusFromPortal()">Query current card status</button>
              </div>
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary">New card status</label>
            <label fxFlex="33" style="text-align: right">
              <mat-select placeholder="Select new card status" [(value)]="newGpsStatusToSet">

                <mat-option [value]="gpsCardStatus.AllGood">00 - All Good</mat-option>
                <mat-option [value]="gpsCardStatus.ReferToCardIssuer">01 - Refer to card issuer</mat-option>
                <mat-option [value]="gpsCardStatus.CardNotYetActivated">02 - Card not yet activated</mat-option>
                <mat-option disabled="disabled" [value]="gpsCardStatus.CaptureCard">04 - Capture card</mat-option>
                <mat-option [value]="gpsCardStatus.DoNotHonour">05 - Do not honour</mat-option>
                <mat-option disabled="disabled" [value]="gpsCardStatus.InvalidCard">14 - Invalid card</mat-option>
                <mat-option [value]="gpsCardStatus.LostCard">41 - Lost card</mat-option>
                <mat-option [value]="gpsCardStatus.StolenCard">43 - Stolen card</mat-option>
                <mat-option [value]="gpsCardStatus.ClosedAccount">46 - Closed Account</mat-option>
                <mat-option disabled="disabled" [value]="gpsCardStatus.ExpiredCard">54 - Expired card</mat-option>
                <mat-option [value]="gpsCardStatus.TransactionNotPermittedToCardholder">57 - Transaction not permitted to cardholder</mat-option>
                <mat-option [value]="gpsCardStatus.SuspectedFraud">59 - Suspected fraud</mat-option>
                <mat-option [value]="gpsCardStatus.RestrictedCard">62 - Restricted card</mat-option>
                <mat-option [value]="gpsCardStatus.SecurityViolation">63 - Security violation</mat-option>
                <mat-option [value]="gpsCardStatus.CardholderToContactIssuer">70 - Cardholder to contact issuer</mat-option>
                <mat-option [value]="gpsCardStatus.AllowableNumberOfPinTriesExceeded">75 - Allowable number of PIN tries exceeded</mat-option>
                <mat-option [value]="gpsCardStatus.CardDestroyed">83 - Card destroyed</mat-option>
                <mat-option [value]="gpsCardStatus.RefundGivenToCustomer">98 - Refund given to customer</mat-option>
                <mat-option [value]="gpsCardStatus.CardVoided">99 - Card voided</mat-option>

                <mat-option [value]="gpsCardStatus.ShortTermBlock">G1 - Short Term Block</mat-option>
                <mat-option [value]="gpsCardStatus.ShortTermFullBlock">G2 - Short Term Full Block</mat-option>
                <mat-option [value]="gpsCardStatus.LongTermBlock">G3 - Long Term Block</mat-option>
                <mat-option [value]="gpsCardStatus.LongTermFullBlock">G4 - Long Term Full Block</mat-option>
              </mat-select>
            </label>
            <label fxFlex="33" style="text-align: right">
              <ng-container *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
                <button [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus || newGpsStatusToSet == null" mat-raised-button color="primary" (click)="setGpsCardStatus(newGpsStatusToSet)">Set card status</button>
              </ng-container>
            </label>
          </div>


          <div class="list-item" fxLayout="row"  *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary">Quick-set Status</label>
            <label fxFlex="66" style="text-align: right">
              <button class="mr-1" [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus" mat-flat-button color="primary" (click)="setGpsCardStatus(gpsCardStatus.AllGood)">All good</button>
              <button [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus" mat-flat-button color="yellow" (click)="setGpsCardStatus(gpsCardStatus.LostCard)">Lost</button>
              <button class="mr-1" [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus" mat-flat-button color="orange" (click)="setGpsCardStatus(gpsCardStatus.LongTermBlock)">G3</button>
              <button [class.spinner]="_isQueryingCardStatus" [disabled]="_isQueryingCardStatus" mat-flat-button color="grey" (click)="setGpsCardStatus(gpsCardStatus.ClosedAccount)">Closed acct</button>
            </label>
          </div>

          <div style="margin-left: 15px;">
          <h5>Card Usage</h5>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Abroad</label>
            <label fxFlex="65">
              <ng-container *ngIf="cardPerms && cardPerms.length >= 3">
                <div *ngIf="cardPerms.substr(0,1) == 'A'; else noabroad"><mat-icon style="color: forestgreen;">check_circle</mat-icon> ON</div>
                <ng-template #noabroad>
                  <mat-icon style="color: red;">close</mat-icon> OFF
                </ng-template>
              </ng-container>

            </label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Online</label>
            <label fxFlex="65">
              <ng-container *ngIf="cardPerms && cardPerms.length >= 3">
                <div *ngIf="cardPerms.substr(1,1) == 'O'; else noabroad"><mat-icon style="color: forestgreen;">check_circle</mat-icon> ON</div>
                <ng-template #noabroad>
                  <mat-icon style="color: red;">close</mat-icon> OFF
                </ng-template>
              </ng-container>

            </label>
          </div>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Cash withdrawal at ATM</label>
            <label fxFlex="65">
              <ng-container *ngIf="cardPerms && cardPerms.length >= 3">
                <div *ngIf="cardPerms.substr(2,1) == 'C'; else noabroad"><mat-icon style="color: forestgreen;">check_circle</mat-icon> ON</div>
                <ng-template #noabroad>
                  <mat-icon style="color: red;">close</mat-icon> OFF
                </ng-template>
              </ng-container>

            </label>
          </div>
          <div class="list-item">
            <label fxFlex="100" style="text-align: right;">
              <div class="mt-1">
                <button [class.spinner]="_isQueryingCardPerms" [disabled]="_isQueryingCardPerms" mat-stroked-button color="primary" (click)="getCardPerms()">Refresh Card Usage</button>
              </div>
            </label>
          </div>

          <h5>Activation</h5>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Card activation</label>
            <label fxFlex="65" style="text-align: right">
              <button [class.spinner]="_isActivatingCard" [disabled]="_isActivatingCard" mat-raised-button color="primary" (click)="activateCard()">Activate Card</button>

            </label>
          </div>

          <h5>PIN Control</h5>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">PIN status</label>
            <label fxFlex="65" style="text-align: right">
              <ng-container *ngIf="pin">
                <div *ngIf="pin.isBlocked">
                  <div style="display: inline-block; margin: 5px; padding: 5px; background-color: orangered">
                  PIN IS BLOCKED!</div> <button [class.spinner]="_isUnblockingPin" [disabled]="_isUnblockingPin" mat-raised-button color="primary" (click)="unblockPin()">Unblock</button>

                </div>
                <div *ngIf="!pin.isBlocked">
                  Pin is OK
                </div>
              </ng-container>
              <div class="mt-1">
                <button [class.spinner]="_isQueryingPinStatus" [disabled]="_isQueryingPinStatus" mat-stroked-button color="primary" (click)="getCardPinStatus()">Get PIN Status</button>
              </div>
            </label>
          </div>

          <h5>Limit Group</h5>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Current Limit Group</label>
            <label fxFlex="65" style="text-align: right">
              <ng-container *ngIf="currentLimitGroup == null; else limitGroupKnown">
                <button [class.spinner]="isQueryingLimitGroup" [disabled]="isQueryingLimitGroup" mat-stroked-button color="primary" (click)="queryLimitGroupFromPortal()">Query current Limit group</button>
              </ng-container>
              <ng-template #limitGroupKnown>
                {{ currentLimitGroup }}
              </ng-template>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
            <label fxFlex="35" class="secondary">New Limit Group</label>
            <label fxFlex="65" style="text-align: right">

              <mat-select placeholder="Select new limit group" [(ngModel)]="newLimitGroupToSelect">
                <mat-option *ngFor="let limitGroup of limitGroups" [value]="limitGroup.code">{{ limitGroup.code }} <small style="color: dimgrey">{{ limitGroup.description}}</small></mat-option>
              </mat-select>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary"></label>
            <label fxFlex="66" style="text-align: right">
              <ng-container *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager()">
                <button [class.spinner]="isQueryingLimitGroup" [disabled]="isQueryingLimitGroup || newLimitGroupToSelect == null || newLimitGroupToSelect == currentLimitGroup" mat-raised-button color="primary" (click)="setLimitGroup(newLimitGroupToSelect)">Set Limit group</button>
              </ng-container>
            </label>
          </div>


          <h5>Card Acceptor - White List</h5>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Current White List</label>
            <label fxFlex="65" style="text-align: right">
              {{ currentWhiteList }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
            <label fxFlex="35" class="secondary">New White List</label>
            <label fxFlex="65" style="text-align: right">

              <mat-select placeholder="Select new white list" [(ngModel)]="newWhiteListToSelect">
                <mat-option *ngFor="let whiteList of whiteLists" [value]="whiteList.listCode">{{ whiteList.listCode }}</mat-option>
              </mat-select>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary"></label>
            <label fxFlex="66" style="text-align: right">
              <ng-container *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager()">
                <button [class.spinner]="isQueryingWhiteList" [disabled]="isQueryingWhiteList || newWhiteListToSelect == null || newWhiteListToSelect == currentWhiteList" mat-raised-button color="primary" (click)="setWhiteList(newWhiteListToSelect)">Set White List</button>
              </ng-container>
            </label>
          </div>

          <h5>Card Acceptor - Black List</h5>
          <div class="list-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Current Black List</label>
            <label fxFlex="65" style="text-align: right">
              {{ currentBlackList }}
            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
            <label fxFlex="35" class="secondary">New Black List</label>
            <label fxFlex="65" style="text-align: right">

              <mat-select placeholder="Select new black list" [(ngModel)]="newBlackListToSelect">
                <mat-option *ngFor="let blackList of blackLists" [value]="blackList.listCode">{{ blackList.listCode }}</mat-option>
              </mat-select>

            </label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="!currentUserIsPartner() && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager())">
            <label fxFlex="33" class="secondary"></label>
            <label fxFlex="66" style="text-align: right">
              <ng-container *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsComplianceManager() || currentUserIsFinanceManager()">
                <button [class.spinner]="isQueryingBlackList" [disabled]="isQueryingBlackList || newBlackListToSelect == null || newBlackListToSelect == currentBlackList" mat-raised-button color="primary" (click)="setBlackList(newBlackListToSelect)">Set Black List</button>
              </ng-container>
            </label>
          </div>


        </ng-container>

      </mat-card-content>

      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Fees</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="_isQueryingCardFees">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <div class="list-item" fxLayout="row">
          <label fxFlex="33" class="secondary">Card Fee Group (GPS)</label>
          <label fxFlex="33" style="text-align: right">
            <div>
              <ng-container *ngIf="!cardFeeGroup; else hasFeeGroup">
                <i>please query if necessary</i>
              </ng-container>
              <ng-template #hasFeeGroup>
                {{ cardFeeGroup }}
              </ng-template>
            </div>

          </label>

          <label fxFlex="33" style="text-align: right">
            <div *ngIf="!currentUserIsPartner()">
              <button [class.spinner]="_isQueryingCardFees" [disabled]="_isQueryingCardFees" mat-stroked-button color="primary" (click)="queryCardFeeGroupFromPortal()">Query Fee Group</button>
            </div>
          </label>
        </div>

        <div class="list-item" fxLayout="row" *ngIf="currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager()">
          <label fxFlex="35" class="secondary">New Fee Group</label>
          <label fxFlex="33" style="text-align: right">
            <mat-select placeholder="Select new fee group" [(value)]="newGpsStatusToSet" [(ngModel)]="newFeeGroup">
              <mat-option *ngFor="let feeGroup of feeGroups" [value]="feeGroup.code">{{feeGroup.code}} - {{feeGroup.description}}</mat-option>
            </mat-select>
          </label>
          <label fxFlex="32" style="text-align: right">
            <button [class.spinner]="_isQueryingCardFees" [disabled]="!newFeeGroup || _isQueryingCardFees" mat-stroked-button color="primary" (click)="setCardFeeGroup(newFeeGroup)">Set {{ newFeeGroup ? newFeeGroup : 'fee group'}}</button>
          </label>
        </div>

        <div class="list-item" fxLayout="row" *ngIf="card && (currentUserIsAdmin() || currentUserIsCompliance() || currentUserIsFinanceManager())">
          <label fxFlex="35" class="secondary">
            <small>Set to product default Fee Group</small>
          </label>
          <label fxFlex="33" style="text-align: right">

          </label>
          <label fxFlex="32" style="text-align: right">
            <div><small>Product default:</small></div>
            <button [class.spinner]="_isQueryingCardFees" [disabled]="_isQueryingCardFees" mat-stroked-button color="primary" (click)="setCardFeeGroup(card.product.feeGroup)">Set to {{ card.product.feeGroup }}</button>

          </label>
        </div>


      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Usage Group</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="_isQueryingCardPermsGroup">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <div class="list-item" fxLayout="row">
          <label fxFlex="33" class="secondary">Perms Group (=Usage Group) (GPS)</label>
          <label fxFlex="33" style="text-align: right">
            <div>
              <ng-container *ngIf="!cardPermsGroup; else hasPermsGroup">
                <i>please query if necessary</i>
              </ng-container>
              <ng-template #hasPermsGroup>
                {{ cardPermsGroup }}
              </ng-template>
            </div>

          </label>

          <label fxFlex="33" style="text-align: right">
            <div *ngIf="!currentUserIsPartner()">
              <button [class.spinner]="_isQueryingCardPermsGroup" [disabled]="_isQueryingCardPermsGroup" mat-stroked-button color="primary" (click)="queryCardPermsGroupFromPortal()">Query Perms Group</button>
            </div>
          </label>
        </div>


      </mat-card-content>
    </mat-card>



    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5 class="h-condensed">Limit usage</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <ng-container *ngIf="_isQueryingCardLimitStats">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <div *ngIf="limitStats">

          <div style="margin-left: 15px;">
            <b>Limit Group: {{ limitStats.limitGroupCode }} ({{ limitStats.limitGroupName }})</b>
          </div>

          <h5>{{limitStats.days1}} days</h5>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Pos / Online</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.posOnlineAmount1 | number : '1.2-2' }} / {{limitStats.posOnlineAmountLimit1 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.posOnlineCount1}} / {{limitStats.posOnlineCountLimit1}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.posOnlineAmount1 / limitStats.posOnlineAmountLimit1 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.posOnlineCount1 / limitStats.posOnlineCountLimit1 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">ATM</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.atmAmount1 | number : '1.2-2'}} / {{limitStats.atmAmountLimit1 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.atmCount1}} / {{limitStats.atmCountLimit1}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.atmAmount1 / limitStats.atmAmountLimit1 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.atmCount1 / limitStats.atmCountLimit1 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Load</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.loadAmount1 | number : '1.2-2'}} / {{limitStats.loadAmountLimit1 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.loadCount1}} /  {{limitStats.loadCountLimit1}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.loadAmount1 / limitStats.loadAmountLimit1 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.loadCount1 / limitStats.loadCountLimit1 * 100"></mat-progress-bar>
            </label>
          </div>


          <h5>{{limitStats.days2}} days</h5>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Pos / Online</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.posOnlineAmount2 | number : '1.2-2' }} / {{limitStats.posOnlineAmountLimit2 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.posOnlineCount2}} / {{limitStats.posOnlineCountLimit2}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.posOnlineAmount2 / limitStats.posOnlineAmountLimit2 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.posOnlineCount2 / limitStats.posOnlineCountLimit2 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">ATM</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.atmAmount2 | number : '1.2-2'}} / {{limitStats.atmAmountLimit2 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.atmCount2}} / {{limitStats.atmCountLimit2}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.atmAmount2 / limitStats.atmAmountLimit2 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.atmCount2 / limitStats.atmCountLimit2 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Load</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.loadAmount2 | number : '1.2-2'}} / {{limitStats.loadAmountLimit2 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.loadCount2}} /  {{limitStats.loadCountLimit2}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.loadAmount2 / limitStats.loadAmountLimit2 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.loadCount2 / limitStats.loadCountLimit2 * 100"></mat-progress-bar>
            </label>
          </div>

          <h5>{{limitStats.days3}} days</h5>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Pos / Online</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.posOnlineAmount3 | number : '1.2-2' }} / {{limitStats.posOnlineAmountLimit3 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.posOnlineCount3}} / {{limitStats.posOnlineCountLimit3}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.posOnlineAmount3 / limitStats.posOnlineAmountLimit3 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.posOnlineCount3 / limitStats.posOnlineCountLimit3 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">ATM</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.atmAmount3 | number : '1.2-2'}} / {{limitStats.atmAmountLimit3 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.atmCount3}} / {{limitStats.atmCountLimit3}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.atmAmount3 / limitStats.atmAmountLimit3 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.atmCount3 / limitStats.atmCountLimit3 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="35" class="secondary">Load</label>
            <label fxFlex="35" style="text-align: right">{{limitStats.loadAmount3 | number : '1.2-2'}} / {{limitStats.loadAmountLimit3 | number : '1.2-2' }}</label>
            <label fxFlex="30" style="text-align: right">{{limitStats.loadCount3}} /  {{limitStats.loadCountLimit3}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.loadAmount3 / limitStats.loadAmountLimit3 * 100"></mat-progress-bar>
            </label>
          </div>
          <div class="list-item progress-item blue" fxLayout="row">
            <label fxFlex="100">
              <mat-progress-bar [value]="limitStats.loadCount3 / limitStats.loadCountLimit3 * 100"></mat-progress-bar>
            </label>
          </div>

          <h5>Maximum amounts</h5>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="25" class="secondary">Balance</label>
            <label fxFlex="75">{{limitStats.maxBalance}}</label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="25" class="secondary">ATM per transaction</label>
            <label fxFlex="75">{{limitStats.atmMaxPerTransaction}}</label>
          </div>
          <div class="list-item condensed-item" fxLayout="row">
            <label fxFlex="25" class="secondary">POS/Online per transaction</label>
            <label fxFlex="75">{{limitStats.posOnlineMaxPerTransaction}}</label>
          </div>
          <div class="list-item progress-item" fxLayout="row">
            <label fxFlex="25" class="secondary">Load per transaction</label>
            <label fxFlex="75">{{limitStats.loadMaxPerTransaction}}</label>
          </div>


        </div>

      </mat-card-content>
    </mat-card>


  </div>
</div>





